import { AlertTriangle, Building2, Clock, ExternalLink, Home, Settings } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../services/api';

const VacancyManagement = () => {
  console.log('?? VacancyManagement 而댄룷?뚰듃 留덉슫?몃맖');
  
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');
  const [currentUser, setCurrentUser] = useState(null);
  const [selectedPropertyOwner, setSelectedPropertyOwner] = useState('');
  const [selectedBuilding, setSelectedBuilding] = useState('');
  const [propertyOwners, setPropertyOwners] = useState([]);
  const [buildings, setBuildings] = useState([]);
  
  // ?곗씠???곹깭 異붽?
  const [dashboardData, setDashboardData] = useState(null);
  const [vacantUnits, setVacantUnits] = useState([]);
  const [expiringUnits, setExpiringUnits] = useState([]);
  const [messageHistory, setMessageHistory] = useState([]);
  
  // 以묎컻?붿껌 愿???곹깭
  const [showBrokerageModal, setShowBrokerageModal] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [brokerageForm, setBrokerageForm] = useState({
    request_type: 'rental',
    priority: 'normal',
    description: '',
    expected_rent: '',
    expected_deposit: '',
    contact_person: '',
    contact_phone: '',
    notes: ''
  });
  
  // 硫붿떆吏 諛쒖넚 愿???곹깭
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageForm, setMessageForm] = useState({
    message_type: 'email',
    subject: '',
    content: '',
    recipient_email: '',
    recipient_phone: ''
  });
  
  // ?곸꽭蹂닿린 紐⑤떖 愿???곹깭
  const [showDetailModal, setShowDetailModal] = useState(false);
  
  // 硫붿떆吏 ?쒗뵆由?愿???곹깭
  const [messageTemplates, setMessageTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log('?봽 useEffect ?ㅽ뻾: loadCurrentUser ?몄텧');
    loadCurrentUser();
    loadMessageTemplates();
  }, []);

  useEffect(() => {
    if (selectedPropertyOwner && currentUser?.role === 'rental_management_company') {
      loadBuildings();
    } else {
      setBuildings([]);
    }
  }, [selectedPropertyOwner, currentUser]);

  // ?꾪꽣 蹂寃????곗씠???щ줈??
  useEffect(() => {
    console.log('?봽 ?곗씠??濡쒕뱶 useEffect ?ㅽ뻾:', { currentUser, selectedPropertyOwner, selectedBuilding });
    if (currentUser) {
      console.log('??currentUser ?덉쓬, ?곗씠??濡쒕뱶 ?쒖옉');
      loadBuildings(); // 嫄대Ъ 紐⑸줉 濡쒕뱶 異붽?
      loadDashboardData();
      loadVacantUnits();
      loadExpiringUnits();
    } else {
      console.log('??currentUser ?놁쓬');
    }
  }, [selectedPropertyOwner, selectedBuilding, currentUser]);

  const loadCurrentUser = async () => {
    try {
      console.log('?뵇 ?ъ슜???뺣낫 濡쒕뱶 ?쒖옉');
      const response = await api.get('/auth/me');
      console.log('???ъ슜???뺣낫:', response);
      setCurrentUser(response);
      
      if (response?.role === 'rental_management_company') {
        loadPropertyOwners();
      }
    } catch (error) {
      console.error('???ъ슜???뺣낫 濡쒕뱶 ?ㅽ뙣:', error);
    }
  };

  // 硫붿떆吏 ?쒗뵆由?濡쒕뱶
  const loadMessageTemplates = async () => {
    try {
      const response = await api.get('/message-templates');
      if (response.success) {
        setMessageTemplates(response.data);
      }
    } catch (error) {
      console.error('硫붿떆吏 ?쒗뵆由?濡쒕뱶 ?ㅽ뙣:', error);
    }
  };

  const loadPropertyOwners = async () => {
    try {
      const response = await api.get('/rmc/property-owners');
      setPropertyOwners(response);
    } catch (error) {
      console.error('?꾨??ъ뾽??紐⑸줉 濡쒕뱶 ?ㅽ뙣:', error);
    }
  };

  const loadBuildings = async () => {
    try {
      if (currentUser?.role === 'rental_management_company') {
        // RMC ?ъ슜?먮뒗 ?좏깮???꾨??ъ뾽?먯쓽 嫄대Ъ
        const url = selectedPropertyOwner 
          ? `/buildings?property_owner_id=${selectedPropertyOwner}`
          : '/buildings';
        const response = await api.get(url);
        setBuildings(response);
      } else {
        // ?꾨??ъ뾽???ъ슜?먮뒗 ?먯떊??嫄대Ъ
        const response = await api.get('/buildings');
        setBuildings(response);
      }
    } catch (error) {
      console.error('嫄대Ъ 紐⑸줉 濡쒕뱶 ?ㅽ뙣:', error);
    }
  };

  const handlePropertyOwnerChange = (ownerId) => {
    setSelectedPropertyOwner(ownerId);
    setSelectedBuilding('');
  };

  // ??쒕낫???곗씠??濡쒕뱶
  const loadDashboardData = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      if (selectedPropertyOwner) {
        params.append('property_owner_id', selectedPropertyOwner);
      }
      if (selectedBuilding) {
        params.append('building_id', selectedBuilding);
      }
      const url = params.toString() ? `/vacancy/dashboard?${params.toString()}` : '/vacancy/dashboard';
      console.log('?뵇 ??쒕낫??API ?몄텧:', url);
      const response = await api.get(url);
      console.log('????쒕낫??API ?묐떟:', response);
      setDashboardData(response.data);
    } catch (error) {
      console.error('????쒕낫???곗씠??濡쒕뱶 ?ㅽ뙣:', error);
      console.error('?ㅻ쪟 ?곸꽭:', error.response?.data || error.message);
      setDashboardData({
        total_buildings: 0,
        total_units: 0,
        vacant_units: 0,
        expiring_contracts: 0
      });
    } finally {
      setLoading(false);
    }
  };

  // 怨듭떎 ?몃? 濡쒕뱶
  const loadVacantUnits = async () => {
    try {
      const params = new URLSearchParams();
      if (selectedPropertyOwner) {
        params.append('property_owner_id', selectedPropertyOwner);
      }
      if (selectedBuilding) {
        params.append('building_id', selectedBuilding);
      }
      const url = params.toString() ? `/vacancy/vacant-units?${params.toString()}` : '/vacancy/vacant-units';
      const response = await api.get(url);
      setVacantUnits(response.data);
    } catch (error) {
      console.error('怨듭떎 ?몃? 濡쒕뱶 ?ㅽ뙣:', error);
      setVacantUnits([]);
    }
  };

  // 留뚭린?덉젙 ?몃? 濡쒕뱶
  const loadExpiringUnits = async () => {
    try {
      const params = new URLSearchParams();
      if (selectedPropertyOwner) {
        params.append('property_owner_id', selectedPropertyOwner);
      }
      if (selectedBuilding) {
        params.append('building_id', selectedBuilding);
      }
      const url = params.toString() ? `/vacancy/expiring-units?${params.toString()}` : '/vacancy/expiring-units';
      const response = await api.get(url);
      setExpiringUnits(response);
    } catch (error) {
      console.error('留뚭린?덉젙 ?몃? 濡쒕뱶 ?ㅽ뙣:', error);
      setExpiringUnits([]);
    }
  };

  // 硫붿떆吏 ?대젰 濡쒕뱶
  const loadMessageHistory = async () => {
    try {
      const response = await api.get('/vacancy/message-history');
      setMessageHistory(response);
    } catch (error) {
      console.error('硫붿떆吏 ?대젰 濡쒕뱶 ?ㅽ뙣:', error);
      setMessageHistory([]);
    }
  };

  // 以묎컻?붿껌 泥섎━
  const handleBrokerageRequest = (unit) => {
    // ?곗씠?곕쿋?댁뒪 ?뚯씠釉??앹꽦 ???쒖꽦???덉젙
    alert('중개요청 기능은 데이터베이스 테이블 생성 후 활성화될 예정입니다.\n\n선택한 호실: ' + unit.building_name + ' ' + unit.unit_number + '호');
  };

  // 以묎컻?붿껌 ?앹꽦
  const createBrokerageRequest = async () => {
    if (!selectedUnit) return;
    
    try {
      setLoading(true);
      const response = await api.post('/vacancy/brokerage-requests', {
        unit_id: selectedUnit.unit_id || selectedUnit.id,
        request_type: brokerageForm.request_type,
        priority: brokerageForm.priority,
        description: brokerageForm.description,
        expected_rent: brokerageForm.expected_rent ? parseFloat(brokerageForm.expected_rent) : null,
        expected_deposit: brokerageForm.expected_deposit ? parseFloat(brokerageForm.expected_deposit) : null,
        contact_person: brokerageForm.contact_person,
        contact_phone: brokerageForm.contact_phone,
        notes: brokerageForm.notes
      });
      
      if (response.success) {
        alert('以묎컻?붿껌???깃났?곸쑝濡??앹꽦?섏뿀?듬땲??');
        setShowBrokerageModal(false);
        // 以묎컻?붿껌 紐⑸줉 ?덈줈怨좎묠 (?꾩슂??
      } else {
        alert('以묎컻?붿껌 ?앹꽦???ㅽ뙣?덉뒿?덈떎: ' + response.error);
      }
    } catch (error) {
      console.error('以묎컻?붿껌 ?앹꽦 ?ㅽ뙣:', error);
      alert('以묎컻?붿껌 ?앹꽦???ㅽ뙣?덉뒿?덈떎.');
    } finally {
      setLoading(false);
    }
  };

  // ?곸꽭蹂닿린 泥섎━
  const handleViewDetails = (unit) => {
    setSelectedUnit(unit);
    setShowDetailModal(true);
  };

  // 怨꾩빟?곗옣?뺤씤?붿껌 泥섎━
  const handleContractRenewalInquiry = (unit) => {
    setSelectedUnit(unit);
    setMessageForm({
      message_type: 'email',
      subject: '[계약연장 문의] ' + unit.building_name + ' ' + unit.unit_number + '호',
      content: '안녕하세요.\n\n' + unit.building_name + ' ' + unit.unit_number + '호 계약이 곧 만료 예정입니다.\n\n계약 연장에 대한 의향을 알려주시기 바랍니다.\n\n감사합니다.',
      recipient_email: '',
      recipient_phone: ''
    });
    setShowMessageModal(true);
  };

  // 硫붿떆吏 諛쒖넚 泥섎━
  const handleSendMessage = (unit) => {
    setSelectedUnit(unit);
    const monthlyRent = unit.standard_monthly_rent ? unit.standard_monthly_rent.toLocaleString() + '원' : '미정';
    const deposit = unit.standard_deposit ? unit.standard_deposit.toLocaleString() + '원' : '미정';
    const maintenanceFee = unit.standard_maintenance_fee ? unit.standard_maintenance_fee.toLocaleString() + '원' : '미정';
    
    setMessageForm({
      message_type: 'email',
      subject: '[공실안내] ' + unit.building_name + ' ' + unit.unit_number + '호',
      content: '안녕하세요.\n\n' + unit.building_name + ' ' + unit.unit_number + '호가 현재 공실 상태입니다.\n\n- 건물: ' + unit.building_name + '\n- 호실: ' + unit.unit_number + '호\n- 면적: ' + (unit.area || '-') + '\n- 기준월세: ' + monthlyRent + '\n- 기준보증금: ' + deposit + '\n- 기준관리비: ' + maintenanceFee + '\n\n문의가 있으시면 연락주시기 바랍니다.\n\n감사합니다.',
      recipient_email: '',
      recipient_phone: ''
    });
    setShowMessageModal(true);
  };

  // 硫붿떆吏 ?쒗뵆由??좏깮 泥섎━
  const handleTemplateSelect = (templateId) => {
    const template = messageTemplates.find(t => t.id === templateId);
    if (template) {
      setSelectedTemplate(templateId);
      setMessageForm(prev => ({
        ...prev,
        subject: template.subject || prev.subject,
        content: template.content || prev.content
      }));
    }
  };

  // 硫붿떆吏 諛쒖넚 ?ㅽ뻾
  const sendMessage = async () => {
    if (!selectedUnit) return;
    
    try {
      setLoading(true);
      const response = await api.post('/vacancy/send-messages', {
        unit_ids: [selectedUnit.unit_id || selectedUnit.id],
        message_type: messageForm.message_type,
        subject: messageForm.subject,
        content: messageForm.content,
        recipient_email: messageForm.recipient_email,
        recipient_phone: messageForm.recipient_phone,
        template_id: selectedTemplate
      });
      
      if (response.success) {
        alert('硫붿떆吏媛 ?깃났?곸쑝濡?諛쒖넚?섏뿀?듬땲??');
        setShowMessageModal(false);
        loadMessageHistory(); // 硫붿떆吏 ?대젰 ?덈줈怨좎묠
      } else {
        alert('硫붿떆吏 諛쒖넚???ㅽ뙣?덉뒿?덈떎: ' + response.error);
      }
    } catch (error) {
      console.error('硫붿떆吏 諛쒖넚 ?ㅽ뙣:', error);
      alert('硫붿떆吏 諛쒖넚???ㅽ뙣?덉뒿?덈떎.');
    } finally {
      setLoading(false);
    }
  };

  const sendVacancyKakao = async (message) => {
    if (!window.confirm('怨듭떎 ?곹깭 ?뚮┝?≪쓣 諛쒖넚 ?붿껌?좉퉴??')) return;
    try {
      const response = await api.post('/message-master/vacancy-messages/' + message.id + '/send', {});
      alert('알림톡 요청 완료: ' + (response.status || response.data?.status || 'READY'));
    } catch (error) {
      alert(error.response?.data?.message || '?뚮┝???붿껌???ㅽ뙣?덉뒿?덈떎.');
    }
  };

  const sendContractExpiryKakao = async (unit) => {
    if (!window.confirm('怨꾩빟留뚮즺 ?뚮┝?≪쓣 諛쒖넚 ?붿껌?좉퉴??')) return;
    try {
      const response = await api.post('/message-master/contracts/' + unit.contract_id + '/expiry/send', {});
      alert('알림톡 요청 완료: ' + (response.status || response.data?.status || 'READY'));
    } catch (error) {
      alert(error.response?.data?.message || '?뚮┝???붿껌???ㅽ뙣?덉뒿?덈떎.');
    }
  };

  const expiryResponseBadgeClass = (unit) => {
    if (unit.expiry_response_type === 'RENEWAL_INTEREST') return 'bg-blue-100 text-blue-800';
    if (unit.expiry_response_type === 'MOVE_OUT_INTENT') return 'bg-orange-100 text-orange-800';
    return 'bg-gray-100 text-gray-700';
  };

  const formatExpiryRespondedAt = (value) => {
    if (!value) return '';
    return String(value).slice(0, 10);
  };

  const FilterSection = () => {
    return (
      <div className="bg-white rounded-lg shadow p-4 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* ?꾨??ъ뾽???꾪꽣 (RMC ?ъ슜?먯슜) */}
          {currentUser?.role === 'rental_management_company' && (
            <div className="flex items-center gap-2">
              <Home className="h-5 w-5 text-gray-400" />
              <label className="text-sm font-medium text-gray-700">?꾨??ъ뾽??</label>
              <select
                value={selectedPropertyOwner}
                onChange={(e) => handlePropertyOwnerChange(e.target.value)}
                className="flex-1 border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
              >
                <option value="">전체 임대사업자</option>
                {propertyOwners?.map((owner) => (
                  <option key={owner.id} value={owner.id}>
                    {owner.name} ({owner.buildings_count}媛?嫄대Ъ)
                  </option>
                ))}
              </select>
            </div>
          )}
          
          {/* 嫄대Ъ ?꾪꽣 (紐⑤뱺 ?ъ슜?먯슜) */}
          <div className="flex items-center gap-2">
            <Home className="h-5 w-5 text-gray-400" />
            <label className="text-sm font-medium text-gray-700">嫄대Ъ:</label>
            <select
              value={selectedBuilding}
              onChange={(e) => setSelectedBuilding(e.target.value)}
              className="flex-1 border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
              disabled={currentUser?.role === 'rental_management_company' && !selectedPropertyOwner}
            >
              <option value="">?꾩껜 嫄대Ъ</option>
              {buildings?.map((building) => (
                <option key={building.id} value={building.id}>
                  {building.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    );
  };

  const DashboardTab = () => {
    const data = dashboardData || {
      total_buildings: 0,
      total_units: 0,
      vacant_units: 0,
      expiring_contracts: 0
    };

    return (
      <div>
        <FilterSection />
        {loading ? (
          <div className="flex justify-center items-center py-8">
            <div className="text-gray-500">?곗씠?곕? 遺덈윭?ㅻ뒗 以?..</div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-center">
                <Building2 className="w-8 h-8 text-blue-600" />
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-600">?꾩껜 嫄대Ъ</p>
                  <p className="text-2xl font-bold text-gray-900">{data.total_buildings}건</p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-center">
                <Home className="w-8 h-8 text-green-600" />
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-600">?꾩껜 ?몃?</p>
                  <p className="text-2xl font-bold text-gray-900">{data.total_units}건</p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-center">
                <AlertTriangle className="w-8 h-8 text-yellow-600" />
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-600">怨듭떎 ?몃?</p>
                  <p className="text-2xl font-bold text-gray-900">{data.vacant_units}건</p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-center">
                <Clock className="w-8 h-8 text-red-600" />
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-600">留뚭린?덉젙</p>
                  <p className="text-2xl font-bold text-gray-900">{data.expiring_contracts}건</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const VacantUnitsTab = () => (
    <div>
      <FilterSection />
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">怨듭떎 ?몃? ?꾪솴</h3>
        </div>
        <div className="overflow-x-auto">
          {vacantUnits.length > 0 ? (
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">건물명</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">?몃??몄닔</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">硫댁쟻</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">湲곗??붿꽭</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">기준보증금</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">?곹깭</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">?≪뀡</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {vacantUnits.map((unit) => (
                  <tr key={unit.unit_id || unit.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{unit.building_name}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{unit.unit_number}호</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{unit.area}㎡</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{unit.standard_monthly_rent?.toLocaleString() || '-'}원</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{unit.standard_deposit?.toLocaleString() || '-'}원</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                        怨듭떎
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleViewDetails(unit)}
                          className="text-gray-600 hover:text-gray-900 bg-gray-50 hover:bg-gray-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                        >
                          ?곸꽭蹂닿린
                        </button>
                        <button
                          onClick={() => handleSendMessage(unit)}
                          className="text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                        >
                          硫붿떆吏諛쒖넚
                        </button>
                        <button
                          onClick={() => handleBrokerageRequest(unit)}
                          className="text-indigo-600 hover:text-indigo-900 bg-indigo-50 hover:bg-indigo-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                        >
                          以묎컻?붿껌
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="p-6 text-center text-gray-500">
              <p>怨듭떎 ?몃?媛 ?놁뒿?덈떎.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const ExpiringUnitsTab = () => (
    <div>
      <FilterSection />
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">留뚭린 ?덉젙 怨꾩빟</h3>
        </div>
        <div className="overflow-x-auto">
          {expiringUnits.length > 0 ? (
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">嫄대Ъ/?몃?</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">임차인</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">만기일</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">?⑥??쇱닔</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">의사상태</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">?붿꽭</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">?≪뀡</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {expiringUnits.map((unit) => (
                  <tr key={unit.unit_id || unit.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <Building2 className="w-4 h-4 text-gray-400 mr-2" />
                        <div>
                          <div className="text-sm font-medium text-gray-900">{unit.building_name}</div>
                          <div className="text-sm text-gray-500">{unit.unit_number}호</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{unit.tenant_name}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{unit.end_date}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={'inline-flex px-2 py-1 text-xs font-semibold rounded-full ' + (
                        unit.days_until_expiry <= 7 ? 'bg-red-100 text-red-800' :
                        unit.days_until_expiry <= 14 ? 'bg-yellow-100 text-yellow-800' :
                        'bg-green-100 text-green-800'
                      )}>
                        {unit.days_until_expiry}??
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      <span className={'inline-flex px-2 py-1 text-xs font-semibold rounded-full ' + expiryResponseBadgeClass(unit)}>
                        {unit.expiry_response_label || '의사 미확인'}
                      </span>
                      {unit.expiry_responded_at && (
                        <div className="mt-1 text-xs text-gray-500">{formatExpiryRespondedAt(unit.expiry_responded_at)}</div>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{unit.monthly_rent?.toLocaleString()}원</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleViewDetails(unit)}
                          className="text-gray-600 hover:text-gray-900 bg-gray-50 hover:bg-gray-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                        >
                          ?곸꽭蹂닿린
                        </button>
                        <button
                          onClick={() => handleContractRenewalInquiry(unit)}
                          className="text-green-600 hover:text-green-900 bg-green-50 hover:bg-green-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                        >
                          怨꾩빟?곗옣?뺤씤?붿껌
                        </button>
                        <button
                          onClick={() => sendContractExpiryKakao(unit)}
                          className="text-purple-600 hover:text-purple-900 bg-purple-50 hover:bg-purple-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                        >
                          알림톡
                        </button>
                        {unit.expiry_response_type === 'RENEWAL_INTEREST' && (
                          <Link
                            to="/contracts"
                            className="text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                          >
                            계약 확인
                          </Link>
                        )}
                        {unit.expiry_response_type === 'MOVE_OUT_INTENT' && (
                          <Link
                            to="/rmc/move-in-out"
                            className="text-orange-600 hover:text-orange-900 bg-orange-50 hover:bg-orange-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                          >
                            퇴실 업무
                          </Link>
                        )}
                        <button
                          onClick={() => handleBrokerageRequest(unit)}
                          className="text-indigo-600 hover:text-indigo-900 bg-indigo-50 hover:bg-indigo-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                        >
                          以묎컻?섎ː
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="p-6 text-center text-gray-500">
              <p>留뚭린 ?덉젙??怨꾩빟???놁뒿?덈떎.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const HistoryTab = () => (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="px-6 py-4 border-b border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">硫붿떆吏 諛쒖넚 ?대젰</h3>
      </div>
      <div className="overflow-x-auto">
        {messageHistory.length > 0 ? (
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">諛쒖넚?쇱떆</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">嫄대Ъ/?몃?</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">諛쒖넚?좏삎</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">수신자</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">?곹깭</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">?댁슜</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">알림톡</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {messageHistory.map((message) => (
                <tr key={message.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {new Date(message.created_at).toLocaleString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {message.building_name} {message.unit_number}??
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      {message.message_type === 'sms' ? (
                        <AlertTriangle className="w-4 h-4 text-blue-600 mr-1" />
                      ) : (
                        <Settings className="w-4 h-4 text-green-600 mr-1" />
                      )}
                      <span className="text-sm text-gray-900">
                        {message.message_type === 'sms' ? 'SMS' : '이메일'}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {message.recipient_name} ({message.recipient_type === 'broker' ? '중개사' : '임차인'})
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={'inline-flex px-2 py-1 text-xs font-semibold rounded-full ' + (
                      message.status === 'sent' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                    )}>
                      {message.status === 'sent' ? '발송완료' : '발송대기'}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">
                    {message.content}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <button
                      onClick={() => sendVacancyKakao(message)}
                      className="text-indigo-600 hover:text-indigo-900 bg-indigo-50 hover:bg-indigo-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                    >
                      발송
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="p-6 text-center text-gray-500">
            <p>諛쒖넚??硫붿떆吏媛 ?놁뒿?덈떎.</p>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">공실관리</h1>
        <p className="text-gray-600">怨듭떎 ?꾪솴怨?留뚭린?덉젙 怨꾩빟??愿由ы븯?몄슂</p>
      </div>

      <div className="mb-6">
        <nav className="flex space-x-8">
          <button
            onClick={() => setActiveTab('dashboard')}
            className={'py-2 px-1 border-b-2 font-medium text-sm ' + (
              activeTab === 'dashboard'
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            )}
          >
            ?꾩껜?꾪솴
          </button>
          <button
            onClick={() => setActiveTab('vacant')}
            className={'py-2 px-1 border-b-2 font-medium text-sm ' + (
              activeTab === 'vacant'
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            )}
          >
            怨듭떎?꾪솴
          </button>
          <button
            onClick={() => setActiveTab('expiring')}
            className={'py-2 px-1 border-b-2 font-medium text-sm ' + (
              activeTab === 'expiring'
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            )}
          >
            留뚭린?덉젙
          </button>
          <button
            onClick={() => setActiveTab('history')}
            className={'py-2 px-1 border-b-2 font-medium text-sm ' + (
              activeTab === 'history'
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            )}
          >
            以묎컻?붿껌?댁뿭
          </button>
          <Link
            to="/common-modules"
            className="py-2 px-1 border-b-2 font-medium text-sm border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 flex items-center"
          >
            <Settings className="w-4 h-4 mr-2" />
            怨듯넻紐⑤뱢愿由?
            <ExternalLink className="w-3 h-3 ml-1" />
          </Link>
        </nav>
      </div>

      {activeTab === 'dashboard' && <DashboardTab />}
      {activeTab === 'vacant' && <VacantUnitsTab />}
      {activeTab === 'expiring' && <ExpiringUnitsTab />}
      {activeTab === 'history' && <HistoryTab />}

      {/* 硫붿떆吏 諛쒖넚 紐⑤떖 */}
      {showMessageModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
            <div className="mt-3">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-medium text-gray-900">硫붿떆吏 諛쒖넚</h3>
                <button
                  onClick={() => setShowMessageModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  횞
                </button>
              </div>
              
              {selectedUnit && (
                <div className="mb-4 p-3 bg-gray-50 rounded-md">
                  <p className="text-sm text-gray-600">
                    <strong>?좏깮???몃?:</strong> {selectedUnit.building_name} {selectedUnit.unit_number}??
                  </p>
                </div>
              )}

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    硫붿떆吏 ?쒗뵆由?
                  </label>
                  <select
                    value={selectedTemplate}
                    onChange={(e) => handleTemplateSelect(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">?쒗뵆由??좏깮 (?좏깮?ы빆)</option>
                    {messageTemplates.map((template) => (
                      <option key={template.id} value={template.id}>
                        {template.template_name} - {template.category}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    諛쒖넚 諛⑹떇
                  </label>
                  <select
                    value={messageForm.message_type}
                    onChange={(e) => setMessageForm({...messageForm, message_type: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="email">이메일</option>
                    <option value="sms">SMS</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    ?쒕ぉ
                  </label>
                  <input
                    type="text"
                    value={messageForm.subject}
                    onChange={(e) => setMessageForm({...messageForm, subject: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="메시지 제목을 입력하세요"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    ?댁슜
                  </label>
                  <textarea
                    value={messageForm.content}
                    onChange={(e) => setMessageForm({...messageForm, content: e.target.value})}
                    rows={4}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="메시지 내용을 입력하세요"
                  />
                </div>

                {messageForm.message_type === 'email' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      ?섏떊???대찓??
                    </label>
                    <input
                      type="email"
                      value={messageForm.recipient_email}
                      onChange={(e) => setMessageForm({...messageForm, recipient_email: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="수신자 이메일을 입력하세요"
                    />
                  </div>
                )}

                {messageForm.message_type === 'sms' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      ?섏떊???꾪솕踰덊샇
                    </label>
                    <input
                      type="tel"
                      value={messageForm.recipient_phone}
                      onChange={(e) => setMessageForm({...messageForm, recipient_phone: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="수신자 전화번호를 입력하세요"
                    />
                  </div>
                )}
              </div>

              <div className="flex justify-end space-x-3 mt-6">
                <button
                  onClick={() => setShowMessageModal(false)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                  disabled={loading}
                >
                  痍⑥냼
                </button>
                <button
                  onClick={sendMessage}
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50"
                  disabled={loading}
                >
                  {loading ? '諛쒖넚 以?..' : '諛쒖넚'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ?곸꽭蹂닿린 紐⑤떖 */}
      {showDetailModal && selectedUnit && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-2/3 max-w-4xl shadow-lg rounded-md bg-white">
            <div className="mt-3">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-medium text-gray-900">?몃? ?곸꽭 ?뺣낫</h3>
                <button
                  onClick={() => setShowDetailModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  횞
                </button>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <h4 className="text-md font-medium text-gray-900 border-b pb-2">湲곕낯 ?뺣낫</h4>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">嫄대Ъ紐?</span>
                      <span className="text-sm font-medium">{selectedUnit.building_name}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">?몃??몄닔:</span>
                      <span className="text-sm font-medium">{selectedUnit.unit_number}호</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">硫댁쟻:</span>
                      <span className="text-sm font-medium">{selectedUnit.area}㎡</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">?몃??좏삎:</span>
                      <span className="text-sm font-medium">{selectedUnit.unit_type || '-'}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">痢듭닔:</span>
                      <span className="text-sm font-medium">{selectedUnit.floor}층</span>
                    </div>
                  </div>
                </div>

                <div className="space-y-4">
                  <h4 className="text-md font-medium text-gray-900 border-b pb-2">?꾨? ?뺣낫</h4>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">湲곗??붿꽭:</span>
                      <span className="text-sm font-medium">
                        {selectedUnit.standard_monthly_rent?.toLocaleString() || '-'}??
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">湲곗?蹂댁쬆湲?</span>
                      <span className="text-sm font-medium">
                        {selectedUnit.standard_deposit?.toLocaleString() || '-'}??
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">湲곗?愿由щ퉬:</span>
                      <span className="text-sm font-medium">
                        {selectedUnit.standard_maintenance_fee?.toLocaleString() || '-'}??
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">?곹깭:</span>
                      <span className={'inline-flex px-2 py-1 text-xs font-semibold rounded-full ' + (
                        selectedUnit.status === 'available' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                      )}>
                        {selectedUnit.status === 'available' ? '공실' : '임대중'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-6 pt-4 border-t">
                <div className="flex justify-end space-x-3">
                  <button
                    onClick={() => setShowDetailModal(false)}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
                  >
                    ?リ린
                  </button>
                  <button
                    onClick={() => {
                      setShowDetailModal(false);
                      handleSendMessage(selectedUnit);
                    }}
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
                  >
                    硫붿떆吏 諛쒖넚
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 以묎컻?붿껌 紐⑤떖 */}
      {showBrokerageModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
            <div className="mt-3">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-medium text-gray-900">以묎컻?붿껌</h3>
                <button
                  onClick={() => setShowBrokerageModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  횞
                </button>
              </div>
              
              {selectedUnit && (
                <div className="mb-4 p-3 bg-gray-50 rounded-md">
                  <p className="text-sm text-gray-600">
                    <strong>?좏깮???몃?:</strong> {selectedUnit.building_name} {selectedUnit.unit_number}??
                  </p>
                </div>
              )}

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    ?붿껌 ?좏삎
                  </label>
                  <select
                    value={brokerageForm.request_type}
                    onChange={(e) => setBrokerageForm({...brokerageForm, request_type: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="rental">?꾨?</option>
                    <option value="sale">留ㅻℓ</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    ?곗꽑?쒖쐞
                  </label>
                  <select
                    value={brokerageForm.priority}
                    onChange={(e) => setBrokerageForm({...brokerageForm, priority: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="low">??쓬</option>
                    <option value="normal">蹂댄넻</option>
                    <option value="high">?믪쓬</option>
                    <option value="urgent">湲닿툒</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    ?붿껌 ?댁슜
                  </label>
                  <textarea
                    value={brokerageForm.description}
                    onChange={(e) => setBrokerageForm({...brokerageForm, description: e.target.value})}
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="중개요청 내용을 입력하세요"
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      ?덉긽 ?꾨?猷?
                    </label>
                    <input
                      type="number"
                      value={brokerageForm.expected_rent}
                      onChange={(e) => setBrokerageForm({...brokerageForm, expected_rent: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="예상 임대료"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      ?덉긽 蹂댁쬆湲?
                    </label>
                    <input
                      type="number"
                      value={brokerageForm.expected_deposit}
                      onChange={(e) => setBrokerageForm({...brokerageForm, expected_deposit: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="보증금"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    ?대떦??
                  </label>
                  <input
                    type="text"
                    value={brokerageForm.contact_person}
                    onChange={(e) => setBrokerageForm({...brokerageForm, contact_person: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="?대떦???대쫫"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    ?곕씫泥?
                  </label>
                  <input
                    type="tel"
                    value={brokerageForm.contact_phone}
                    onChange={(e) => setBrokerageForm({...brokerageForm, contact_phone: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="연락처"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    鍮꾧퀬
                  </label>
                  <textarea
                    value={brokerageForm.notes}
                    onChange={(e) => setBrokerageForm({...brokerageForm, notes: e.target.value})}
                    rows={2}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="異붽? ?ы빆"
                  />
                </div>
              </div>

              <div className="flex justify-end space-x-3 mt-6">
                <button
                  onClick={() => setShowBrokerageModal(false)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                  disabled={loading}
                >
                  痍⑥냼
                </button>
                <button
                  onClick={createBrokerageRequest}
                  className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700 disabled:opacity-50"
                  disabled={loading}
                >
                  {loading ? '?앹꽦 以?..' : '以묎컻?붿껌 ?앹꽦'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VacancyManagement;
